import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import clsx from 'clsx';

type Props = {
  variant: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
  children: string | ReactNode;
  className?: string;
};

export default function Alert({ variant, className, children }: Props): ReactElement {
  return (
    <div className={clsx(`alert alert-${variant}`, className)} role="alert">
      {children}
    </div>
  );
}
